import  { useState } from 'react'
import { useAuthUser, useSignIn } from 'react-auth-kit'
import { useNavigate } from 'react-router-dom'

import { 
  Box, Button, TextField, IconButton, InputAdornment
} from '@mui/material'

import { Visibility, VisibilityOff } from '@mui/icons-material'

import "../App.css"

const API = process.env.REACT_APP_API_URL

const Login = () => {


const [userEmail, setUserEmail] = useState('')
const [password, setPassword] = useState('')
const [showPassword, setShowPassword] = useState(false)

const [isLoggingIn, setIsLoggingIn] = useState(false)

const [errorDetails, setErrorDetails] = useState({ hasError: false, message: '' })

const signIn = useSignIn()
const navigate = useNavigate()


const postLoginCreds = (userEmail: string, password: string) => {


  setIsLoggingIn(true)

  fetch(API + '/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userEmail, password })
  })
  .then((res) => {
    
    if (res.status >= 400){
      
      console.error('400+ Response Status')
      
      return res.json()
        .then(res => {

          return { badRequest: true, message: res.message || 'Something Unexpected Went Wrong!' }
      
        }) 

        
      }

    return res.json()
  
  })
  .then(res => {

    if (res.badRequest){
      setIsLoggingIn(false)
      return setErrorDetails({ 
        hasError: true, message: res.message 
      })
    }


    signIn({
      token: res.token,
      expiresIn: 36000,
      tokenType: 'Bearer',
      authState: { user: res.user, token: res.token }
    })

    navigate('/')

  })
  .catch(e => {
    console.log('Error Caught : ', e)
    setIsLoggingIn(false)
    return setErrorDetails({ hasError: true, message: 'Something Unexpected Went Wrong!' })

  })
}

    return (
      <div className="centeredOnPage">
        <Box 
          sx={{ width: '100%',display: 'flex', flexDirection: 'column',alignItems: 'center' }} 
          component='form'
          // autoComplete="off"
          onSubmit={(e: any) => {
            e.preventDefault()
            postLoginCreds(userEmail, password)
          }}
        >
          <TextField
            id="user-email-input"
            variant="standard"
            // variant='filled'
            // sx={{ marginRight: '3%', width: '50%' }}
            sx={{ marginBottom: '3%', width: '50%' }}

            // placeholder="User Email"
            type='email'
            value={userEmail}
            onChange={(e) => setUserEmail(e.target.value)}
            disabled={isLoggingIn}
            label="Email"
          />
          
          <TextField
            id="password-input"
            variant="standard" 
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={isLoggingIn}
            InputProps={{
              endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                  // onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
              )
          }}
            label="Password"
            // sx={{ marginRight: '5%', width: '50%' }}
            sx={{ marginBottom: '5%', width: '50%' }}
          />
          <Button 
            type='submit'
            // onClick={}
            disabled={isLoggingIn}
            sx={{ marginTop: '1%' }}
              // variant="outlined"              
            variant="contained"
            >
              <span>Login</span>
          </Button>
          
        </Box>
         
        {errorDetails.hasError &&  
            <div className="dangerMsg">
                <span>{errorDetails.message}</span>
                <button 
                    className="hoverable"
                    onClick={() => {
                      setErrorDetails({ hasError: false, message: '' })
                    }}
                >X</button>
            </div>
        }
        
      
      </div>
    )

}


export default Login